var _ellipse, _ellipse2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInviteStaffIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.3591,
    cy: 18.7185,
    rx: 6.24,
    ry: 6.24,
    fill: "#6CCC93"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7214,
    cy: 12.4782,
    rx: 8.32,
    ry: 8.32,
    fill: "#256AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9883 35.7025C23.9883 31.8466 27.1141 28.7207 30.9701 28.7207H41.3483C45.2042 28.7207 48.3301 31.8466 48.3301 35.7025V43.7173C48.3301 44.8454 47.4155 45.76 46.2874 45.76H26.0309C24.9028 45.76 23.9883 44.8454 23.9883 43.7173V35.7025Z",
    fill: "#6CCC93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08105 34.3262C2.08105 28.5423 6.76986 23.8535 12.5538 23.8535H23.2527C29.0366 23.8535 33.7254 28.5423 33.7254 34.3262V43.7185C33.7254 44.8466 32.8109 45.7611 31.6827 45.7611H4.12372C2.99559 45.7611 2.08105 44.8466 2.08105 43.7185V34.3262Z",
    fill: "#256AF5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteStaffIc);
export default __webpack_public_path__ + "static/media/invite-staff-ic.959c1df0f86a5e0ea0b8fb27ca40c9aa.svg";
export { ForwardRef as ReactComponent };